import { render } from "./Import.vue?vue&type=template&id=f2a5bd12&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=f2a5bd12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2a5bd12"

export default script